import { ButtonSize } from '../Button';

import {
  Button,
  ButtonType,
  Size,
  TextField,
  TextFieldType,
  TypographySize
} from '~/components/core';

interface InputButtonProps {
  buttonLabel: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  placeholder: string;
  value: string;
  buttonSize?: ButtonSize;
  disabled?: boolean;
  loading?: boolean;
  typographySize?: TypographySize;
  width?: string;
}

const InputButton: React.FC<InputButtonProps> = ({
  disabled = false,
  loading = false,
  buttonLabel,
  placeholder,
  value,
  onChange,
  onSubmit,
  width = 'w-1/2 max-w-[320px]',
  buttonSize = Size.SMALL,
  typographySize = TypographySize.X_SMALL
}) => (
  <div
    className={`flex flex-row items-center ${width}`}
    data-testid="input-button"
    id="input-button-container"
  >
    <div className="flex w-full">
      <TextField
        disabled={disabled}
        fullWidth
        onChange={onChange}
        onEnter={onSubmit}
        placeholder={placeholder}
        size={typographySize}
        type={TextFieldType.INPUT_BUTTON}
        value={value}
      />
    </div>
    <Button
      disabled={disabled || !value}
      label={buttonLabel}
      loading={loading}
      onClick={onSubmit}
      size={buttonSize}
      type={ButtonType.INPUT_BUTTON}
    />
  </div>
);

export default InputButton;
